
import {Component, Watch} from "vue-property-decorator";
import _ from "lodash";
import {getModule} from "vuex-module-decorators";
import {store, TradeInModule, ShopModule, AppModule} from "@returns-centre/store";
import {ValidationErrors, TradeInItemProductList} from "@returns-centre/components"
import {mixins} from 'vue-class-component';
import {FormatDateMixin} from '@returns-centre/mixins';
import { ShippingOptionService } from "@/enums";

@Component({
  components: {
    ValidationErrors,
    TradeInItemProductList
  },
  filters: {
    startCase(val: string): string {
      return val.replace(/\w+/g, _.capitalize);
    }
  }
})
export default class TradeInConfirmation extends mixins(FormatDateMixin) {
  tradeInModule = getModule(TradeInModule, store);
  shopModule = getModule(ShopModule, store);
  appModule = getModule(AppModule, store);

  hasAgreedTermsAndConditions: boolean = false;

  get tradeIn() {
    return {
      ...this.tradeInModule.trade_in,
      ...this.tradeInModule.selected_return_carrier_service,
      deductions: this.tradeInModule.trade_in_price_deductions,
    };
  }

  get returnCarrierServiceName(): string {
    if (this.tradeInModule.selected_return_carrier_service &&
      [ShippingOptionService.custom.toString(), ShippingOptionService.JGS.toString()].includes(this.tradeInModule.selected_return_carrier_service.service_class)
    ) {
        return this.tradeInModule.selected_return_carrier_service?.service_name;
    }

    return `${this.tradeInModule.selected_return_carrier_service?.name} - (${this.tradeInModule.selected_return_carrier_service?.service_name})`;
  }

  getQuantityRange(qty: number): number[] {
    return _.range(qty);
  }

  getProductImage(product: TradeInProductRecord): string {
    if (this.shopModule.shop?.show_product_images && product.image_url) {
      return product.image_url;
    }

    return this.shopModule.shop?.product_image as string;
  }

  @Watch("hasAgreedTermsAndConditions")
  onHasAgreedTermsAndConditionsChanged(val: boolean) {
    this.tradeInModule.setHasAgreedTermsAndConditions(val);
  }
}
